/* eslint-disable @typescript-eslint/no-namespace */ import { AwaMetaTags, Constants } from '@shared/utils/constants';
import { routes } from '@shared/routerHistory';
import { getDocument } from '@shared/services/window';
(function(metaTagConstants) {
    metaTagConstants.viewportName = 'viewport';
    metaTagConstants.viewportValue = 'width=device-width, initial-scale=1';
    metaTagConstants.typeName = 'type';
    metaTagConstants.typeValue = 'Website';
    metaTagConstants.keywordsName = 'keywords';
    metaTagConstants.spzaGalleryWordKeywordsValue = 'word plugin, word apps, word add ons, word extension, word add-ins, grammar, grammer, chatgpt word, word cloud, citation';
    metaTagConstants.spzaGalleryExcelKeywordsValue = 'chatgpt excel, excel chatgpt, excel plugins, excel apps, excel add ons, excel add-ins, excel extensions, ai excel, web viewer';
    metaTagConstants.spzaGalleryPptKeywordsValue = 'ppt plugin, ppt add-ins, ppt apps, ppt add ons, ppt extension, powerpoint add-ins, powerpoint apps, powerpoint plugin, powerpoint add ons, powerpoint extension, power bi visual';
    metaTagConstants.spzaGalleryOutlookKeywordsValue = 'outlook plugin, outlook add-ins, outlook apps, outlook add ons, outlook extension, email recovery';
    metaTagConstants.spzaGalleryOfficeKeywordsValue = 'outlook apps, office store, outlook plugin, word plugin, gpt excel, chatgpt excel, excel plugin, microsoft office store, Business apps, microsoft 365 apps, education apps, word apps, excel apps, sharepoint apps, powerpoint apps, grammar, power bi visual';
    metaTagConstants.spzaGalleryKeywordsValue = 'Business apps, 365 apps, office store, dynamics apps, outlook apps, word apps, government apps, education apps, microsoft office store, excel apps, ppt apps, powerpoint apps, office plugin, excel plugin';
    metaTagConstants.spzaHomeKeywordsValue = 'Business apps, 365 apps, office store apps, dynamics apps, outlook apps, word apps, government apps, education apps, consulting services';
    metaTagConstants.csGalleryKeywordsValue = 'PowerBI consulting services, dynamics consulting services, assessment, briefing, consulting services implementation';
    metaTagConstants.desName = 'description';
    metaTagConstants.csGalleryDesValue = 'Find the consulting services for your platforms: PowerBI, Dynamics, Web Apps. Get solutions tailored to your industry: Agriculture, Education, Distribution, Financial services, Government, Healthcare, Manufacturing, Professional services, Retail and consumer goods.';
    metaTagConstants.spzaHomeDesValue = 'Discover the app for your business needs and explore tailored solutions for various industries. Whether you are seeking Microsoft 365 apps for Word, Excel, PowerPoint, or Outlook, or apps for Power Platform, Dynamics 365, SaaS, we have you covered. Enhance your productivity and streamline your work with our diverse range of plugins, including grammar and citation tools, GPT-powered Word and Excel enhancements, word clouds, and more. Find the right tools to excel in your field and make the most of your software experience, right here.';
    metaTagConstants.spzaWordGalleryDesValue = 'Discover the Word app for your business needs. Explore a diverse range of Word plugins. Whether you are in professional writing, content creation, or any other domain, Word apps are designed to enhance your productivity and simplify your tasks. Unleash the full potential of your documents with tools such as GPT-powered enhancements, grammar and citation plugins, and more.';
    metaTagConstants.spzaExcelGalleryDesValue = 'Discover the Excel app for your business needs. Explore a diverse range of Excel plugins. Whether you are in finance, data analysis, project management, or any other field, our Excel apps are designed to boost your productivity and streamline your work. Unlock the potential of your spreadsheets with tools including GPT-powered enhancements, web viewer, data analysis plugins, and more.';
    metaTagConstants.spzaPptGalleryDesValue = 'Discover the PowerPoint app for your business needs. Explore a diverse range of PowerPoint plugins. Whether you are in sales, education, marketing, or any other sector, our PowerPoint apps are designed to boost your creativity and streamline your presentations. Unleash the full potential of your slides with tools like GPT-powered enhancements, interactive plugins, and more.';
    metaTagConstants.spzaOutlookGalleryDesValue = 'Discover the Outlook app for your business needs. Explore a diverse range of Outlook plugins. Whether you are in sales, education, marketing, or any other sector, our PowerPoint apps are designed to boost your creativity and streamline your presentations. Unleash the full potential of your slides with tools like GPT-powered enhancements, interactive plugins, and more.';
    metaTagConstants.spzaOfficeGalleryDesValue = 'Discover the Office app for your business needs. Explore a diverse range of Word , Excel, PowerPoint, Outlook, Teams, and SharePoint plugins. Whether you are in sales, education, marketing, or any other sector, our apps are designed to boost your creativity and enhance your productivity. Unleash the full potential of your Office suite with tools like GPT-powered plugins, grammar checker, interactive add-ins, and more.';
    metaTagConstants.sitenameName = 'site_name';
    metaTagConstants.sitenameValue = "Appsource \u2013 Business Apps";
    metaTagConstants.titleName = 'title';
    metaTagConstants.csTitleValue = "Appsource \u2013  Consulting services";
    metaTagConstants.urlName = 'url';
    metaTagConstants.localeName = 'locale';
    metaTagConstants.imageName = 'image';
    metaTagConstants.videoName = 'video';
    metaTagConstants.convergedSitenameValue = 'Microsoft Marketplace';
    metaTagConstants.convergedTitleValue = 'Microsoft Marketplace | cloud solutions, AI apps, and agents';
    metaTagConstants.convergedDescriptionValue = "Accelerate your AI transformation with Microsoft Marketplace\u2014your trusted source to find, try, and buy cloud solutions, AI apps, and agents to meet your business needs.";
    metaTagConstants.convergedKeywordsValue = 'Microsoft Marketplace, cloud solutions, AI apps, tools, agents, business solutions';
    metaTagConstants.convergedCSGalleryKeywordsValue = 'PowerBI Professional Services, dynamics Professional Services, assessment, briefing, Professional Services implementation';
    metaTagConstants.convergedCSGalleryDesValue = 'Find the Professional Services for your platforms: PowerBI, Dynamics, Web Apps. Get solutions tailored to your industry: Agriculture, Education, Distribution, Financial services, Government, Healthcare, Manufacturing, Professional services, Retail and consumer goods.';
    metaTagConstants.convergedCSTitleValue = "Microsoft Marketplace \u2013 Professional Services";
    metaTagConstants.spzaEnvironment = 'portal';
    metaTagConstants.spzaUrl = 'https://appsource.microsoft.com';
    metaTagConstants.convergedUrl = 'https://marketplace.microsoft.com';
    metaTagConstants.twitterCard = 'twitter:card';
    metaTagConstants.twitterSite = 'twitter:site';
    metaTagConstants.twitterTitle = 'twitter:title';
    metaTagConstants.twitterDes = 'twitter:description';
    metaTagConstants.twitterImage = 'twitter:image';
    metaTagConstants.twitterCardValue = 'summary';
    metaTagConstants.twitterSiteValue = '@appsource';
})(metaTagConstants || (metaTagConstants = {}));
export function getPreventIndexMetatag(siteEnv) {
    if (siteEnv !== 'prod') {
        const preventIndexMetatag = getDocument().createElement('meta');
        preventIndexMetatag.setAttribute('name', 'robots');
        preventIndexMetatag.setAttribute('content', 'noindex');
        return preventIndexMetatag;
    }
}
const isGallery = (path, galleryType)=>{
    const pathArray = path.split('/');
    return pathArray[pathArray.length - 1].indexOf(galleryType) > -1 || path.indexOf(Constants.category) > -1;
};
export function getMetaTag(key, value) {
    if (value) {
        const metaTag = getDocument().createElement('meta');
        metaTag.setAttribute('name', key);
        metaTag.setAttribute('content', value);
        return metaTag;
    }
}
export function getOGtag(key, value) {
    if (value) {
        const metaTag = getDocument().createElement('meta');
        metaTag.setAttribute('property', `og:${key}`);
        metaTag.setAttribute('content', value);
        return metaTag;
    }
}
export function getViewPortTag() {
    return getMetaTag(metaTagConstants.viewportName, metaTagConstants.viewportValue);
}
export function getWebtypeOGTag() {
    return getOGtag(metaTagConstants.typeName, metaTagConstants.typeValue);
}
export function getAppSourceWordGalleryKeywordsTag() {
    return getMetaTag(metaTagConstants.keywordsName, metaTagConstants.spzaGalleryWordKeywordsValue);
}
export function getAppSourceExcelGalleryKeywordsTag() {
    return getMetaTag(metaTagConstants.keywordsName, metaTagConstants.spzaGalleryExcelKeywordsValue);
}
export function getAppSourcePptGalleryKeywordsTag() {
    return getMetaTag(metaTagConstants.keywordsName, metaTagConstants.spzaGalleryPptKeywordsValue);
}
export function getAppSourceOfficeGalleryKeywordsTag() {
    return getMetaTag(metaTagConstants.keywordsName, metaTagConstants.spzaGalleryOfficeKeywordsValue);
}
export function getAppSourceOutlookGalleryKeywordsTag() {
    return getMetaTag(metaTagConstants.keywordsName, metaTagConstants.spzaGalleryOutlookKeywordsValue);
}
export function getAppSourceGalleryKeywordsTag({ isConverged }) {
    return getMetaTag(metaTagConstants.keywordsName, isConverged ? metaTagConstants.convergedKeywordsValue : metaTagConstants.spzaGalleryKeywordsValue);
}
export function getAppSourceHomeKeywordsTag({ isConverged }) {
    return getMetaTag(metaTagConstants.keywordsName, isConverged ? metaTagConstants.convergedKeywordsValue : metaTagConstants.spzaHomeKeywordsValue);
}
export function getAppSourceCSGalleryKeywordsTag({ isConverged } = {
    isConverged: false
}) {
    return getMetaTag(metaTagConstants.keywordsName, isConverged ? metaTagConstants.convergedCSGalleryKeywordsValue : metaTagConstants.csGalleryKeywordsValue);
}
export function getAppSourceCSGalleryDescriptionTag({ isConverged } = {
    isConverged: false
}) {
    return getMetaTag(metaTagConstants.desName, isConverged ? metaTagConstants.convergedCSGalleryDesValue : metaTagConstants.csGalleryDesValue);
}
export function getAppSourceWordDescriptionTag() {
    return getMetaTag(metaTagConstants.desName, metaTagConstants.spzaWordGalleryDesValue);
}
export function getAppSourceExcelDescriptionTag() {
    return getMetaTag(metaTagConstants.desName, metaTagConstants.spzaExcelGalleryDesValue);
}
export function getAppSourcePptDescriptionTag() {
    return getMetaTag(metaTagConstants.desName, metaTagConstants.spzaPptGalleryDesValue);
}
export function getAppSourceOutlookDescriptionTag() {
    return getMetaTag(metaTagConstants.desName, metaTagConstants.spzaOutlookGalleryDesValue);
}
export function getAppSourceOfficeDescriptionTag() {
    return getMetaTag(metaTagConstants.desName, metaTagConstants.spzaOfficeGalleryDesValue);
}
export function getAppSourceHomeDescriptionTag({ isConverged }) {
    return getMetaTag(metaTagConstants.desName, isConverged ? metaTagConstants.convergedDescriptionValue : metaTagConstants.spzaHomeDesValue);
}
export function getAppSourcePageOGSitename({ isConverged }) {
    return getOGtag(metaTagConstants.sitenameName, isConverged ? metaTagConstants.convergedSitenameValue : metaTagConstants.sitenameValue);
}
export function getAppSourcePageOGTitleTag({ isConverged }) {
    return getOGtag(metaTagConstants.titleName, isConverged ? metaTagConstants.convergedTitleValue : metaTagConstants.sitenameValue);
}
export function getAppSourceCSGalleryOGTitleTag({ isConverged } = {
    isConverged: false
}) {
    return getOGtag(metaTagConstants.titleName, isConverged ? metaTagConstants.convergedCSTitleValue : metaTagConstants.csTitleValue);
}
export function getAppSourceGalleryOGDescriptionTag({ isConverged }) {
    return getOGtag(metaTagConstants.desName, isConverged ? metaTagConstants.convergedDescriptionValue : metaTagConstants.spzaGalleryKeywordsValue);
}
export function getAppSourceWordGalleryOGDescriptionTag() {
    return getOGtag(metaTagConstants.desName, metaTagConstants.spzaWordGalleryDesValue);
}
export function getAppSourcePptGalleryOGDescriptionTag() {
    return getOGtag(metaTagConstants.desName, metaTagConstants.spzaPptGalleryDesValue);
}
export function getAppSourceExcelGalleryOGDescriptionTag() {
    return getOGtag(metaTagConstants.desName, metaTagConstants.spzaExcelGalleryDesValue);
}
export function getAppSourceOutlookGalleryOGDescriptionTag() {
    return getOGtag(metaTagConstants.desName, metaTagConstants.spzaOutlookGalleryDesValue);
}
export function getAppSourceOfficeGalleryOGDescriptionTag() {
    return getOGtag(metaTagConstants.desName, metaTagConstants.spzaOfficeGalleryDesValue);
}
export function getAppSourceHomeOGDescriptionTag({ isConverged }) {
    return getOGtag(metaTagConstants.desName, isConverged ? metaTagConstants.convergedDescriptionValue : metaTagConstants.spzaHomeKeywordsValue);
}
export function getAppSourceCSGalleryOGDescriptionTag({ isConverged } = {
    isConverged: false
}) {
    return getOGtag(metaTagConstants.desName, isConverged ? metaTagConstants.convergedCSGalleryKeywordsValue : metaTagConstants.csGalleryKeywordsValue);
}
export function getAwaMetaTags(state) {
    const awaMetaTags = [];
    if (state === null || state === void 0 ? void 0 : state.config) {
        var _state_users;
        awaMetaTags.push(getMetaTag(AwaMetaTags.locale, state.config.locale));
        var _state_users_signedIn;
        awaMetaTags.push(getMetaTag(AwaMetaTags.signedIn, `${(_state_users_signedIn = (_state_users = state.users) === null || _state_users === void 0 ? void 0 : _state_users.signedIn) !== null && _state_users_signedIn !== void 0 ? _state_users_signedIn : false}`));
    }
    return awaMetaTags;
}
function isCanonicalQueryKey(queryKey) {
    return Constants.KeepInCanonicalFilters.indexOf(queryKey) > -1;
}
const parseFirstFilter = (filterstring)=>{
    return filterstring.split(';')[0].split(Constants.semicolon)[0];
};
function getGalleryCanonicalSuffix(currentUrl) {
    if (currentUrl.split('?').length < 2) {
        return '';
    }
    const queryParamsString = currentUrl.split('?')[1];
    const queryParamsArray = queryParamsString.split('&');
    for (const queryParam of queryParamsArray){
        const queryTuple = queryParam.split('=');
        if (queryTuple.length > 1 && isCanonicalQueryKey(queryTuple[0])) {
            return '?' + parseFirstFilter(queryParam);
        }
    }
    return '';
}
const parseLocale = (path)=>{
    const match = path.match(Constants.SeoLocaleRegex);
    return match ? match[0].substr(1) : Constants.DefaultLocale;
};
export function getCanonicalLink(currentUrl, isMacEnv) {
    const path = currentUrl && currentUrl.split('?')[0] || '';
    let canonicalLink = path;
    const locale = parseLocale(path);
    if (isMacEnv) {
        if (path.indexOf(Constants.appsGallery) > -1 && !isGallery(path, Constants.GalleryTypes.apps)) {
            canonicalLink = path + Constants.appDetailsCanonicalTabSuffix;
        } else if (path.includes('/sitemap')) {
            canonicalLink = `/${locale}/sitemap`;
        } else if (path.split('/').length <= 3) {
            canonicalLink = `/${locale}/`;
        }
    } else {
        if (path.indexOf(Constants.csGallery) > -1) {
            canonicalLink = isGallery(path, Constants.GalleryTypes.consultingServices) ? path + getGalleryCanonicalSuffix(currentUrl) : path;
        } else if (path.indexOf(Constants.appsGallery) > -1) {
            canonicalLink = path + getGalleryCanonicalSuffix(currentUrl);
        } else if (path.indexOf(Constants.product) > -1) {
            canonicalLink = path + Constants.appDetailsCanonicalTabSuffix;
        } else if (path.includes('/sitemap')) {
            canonicalLink = `/${locale}/sitemap`;
        } else {
            canonicalLink = `/${locale}/`;
        }
    }
    return canonicalLink.toLowerCase();
}
export function getCanonicalLinkTag({ path, protocol, host }) {
    const runningEnv = process.env.webAppName;
    const runningOnMac = runningEnv === Constants.canonicalAMPEnvWebAppName;
    const canonicalLink = `${protocol}://${host}${getCanonicalLink(path, runningOnMac)}`;
    const canonicalLinkTag = getDocument().createElement('link');
    canonicalLinkTag.rel = 'canonical';
    canonicalLinkTag.href = canonicalLink;
    return canonicalLinkTag;
}
export function getPageName(renderProps, env) {
    // get cuurent page from pathname and pass to getComponentHTMLData for meta tag
    let page = Constants.PageToGiveMetaTag.PageNotReady;
    const pathNameNoQuery = renderProps.location.pathname.split('?')[0];
    if (env !== metaTagConstants.spzaEnvironment) {
        page = Constants.PageToGiveMetaTag.PageNotReady;
    } else if (pathNameNoQuery === '/' + renderProps.params.locale + routes.home.getPath(null) || pathNameNoQuery === '/' + renderProps.params.locale || pathNameNoQuery === '/' + renderProps.params.locale + '/') {
        page = Constants.PageToGiveMetaTag.SpzaHomePage;
    } else if (renderProps.location.pathname.startsWith('/' + renderProps.params.locale + routes.marketplace.getPath(null))) {
        var _renderProps_query, _renderProps_query1, _renderProps_query2, _renderProps_query3, _renderProps_query4;
        if (((_renderProps_query = renderProps.query) === null || _renderProps_query === void 0 ? void 0 : _renderProps_query.product) === 'word') {
            page = Constants.PageToGiveMetaTag.SpzaWordGalleryPage;
        } else if (((_renderProps_query1 = renderProps.query) === null || _renderProps_query1 === void 0 ? void 0 : _renderProps_query1.product) === 'excel') {
            page = Constants.PageToGiveMetaTag.SpzaExcelGalleryPage;
        } else if (((_renderProps_query2 = renderProps.query) === null || _renderProps_query2 === void 0 ? void 0 : _renderProps_query2.product) === 'powerpoint') {
            page = Constants.PageToGiveMetaTag.SpzaPowerpointGalleryPage;
        } else if (((_renderProps_query3 = renderProps.query) === null || _renderProps_query3 === void 0 ? void 0 : _renderProps_query3.product) === 'outlook') {
            page = Constants.PageToGiveMetaTag.SpzaOutlookGalleryPage;
        } else if (((_renderProps_query4 = renderProps.query) === null || _renderProps_query4 === void 0 ? void 0 : _renderProps_query4.product) === 'office') {
            page = Constants.PageToGiveMetaTag.SpzaOfficeGalleryPage;
        } else {
            page = Constants.PageToGiveMetaTag.SpzaGalleryPage;
        }
    } else if (renderProps.location.pathname === '/' + renderProps.params.locale + routes.marketplaceServices.getPath(null)) {
        page = Constants.PageToGiveMetaTag.SpzaCSGalleryPage;
    } else if (renderProps.params.productId && renderProps.location.pathname.startsWith('/' + renderProps.params.locale + routes.appDetails.getPath({
        productId: renderProps.params.productId,
        entityId: renderProps.params.entityId
    }))) {
        page = Constants.PageToGiveMetaTag.SpzaDetailPage;
    } else if (renderProps.location.pathname.startsWith('/' + renderProps.params.locale + routes.serviceDetail.getPath({
        entityId: renderProps.params.entityId
    }))) {
        page = Constants.PageToGiveMetaTag.SpzaCSDetailPage;
    } else {
        page = Constants.PageToGiveMetaTag.PageNotReady;
    }
    return page;
}
export function formatMetaTags(metaObj) {
    let metaTags = '';
    if (metaObj) {
        for(const key in metaObj){
            if (metaObj[`${key}`] !== '') {
                metaTags += metaObj[`${key}`];
            }
        }
    }
    return metaTags;
}
export function createMetaTags(store, renderProps, page, url) {
    const isConverged = store.getState().config.isConverged;
    const baseURL = isConverged ? metaTagConstants.convergedUrl : metaTagConstants.spzaUrl;
    let metaObj;
    if (page === Constants.PageToGiveMetaTag.SpzaHomePage) {
        metaObj = {
            metaDescription: getAppSourceHomeDescriptionTag({
                isConverged
            }),
            metaKeywords: getAppSourceHomeKeywordsTag({
                isConverged
            }),
            metaOGTitle: getAppSourcePageOGTitleTag({
                isConverged
            }),
            metaOGUrl: getOGtag(metaTagConstants.urlName, `${baseURL}${url}`),
            metaOGDescription: getAppSourceHomeOGDescriptionTag({
                isConverged
            }),
            metaOGLocale: getOGtag(metaTagConstants.localeName, renderProps.params.locale ? renderProps.params.locale : 'en-us'),
            metaOGSiteName: getAppSourcePageOGSitename({
                isConverged
            })
        };
    } else if (page === Constants.PageToGiveMetaTag.SpzaWordGalleryPage) {
        metaObj = {
            metaDescription: getAppSourceWordDescriptionTag(),
            metaKeywords: getAppSourceWordGalleryKeywordsTag(),
            metaOGTitle: getAppSourcePageOGTitleTag({
                isConverged
            }),
            metaOGUrl: getOGtag(metaTagConstants.urlName, `${baseURL}${url}`),
            metaOGDescription: getAppSourceWordGalleryOGDescriptionTag(),
            metaOGLocale: getOGtag(metaTagConstants.localeName, renderProps.params.locale ? renderProps.params.locale : 'en-us'),
            metaOGSiteName: getAppSourcePageOGSitename({
                isConverged
            })
        };
    } else if (page === Constants.PageToGiveMetaTag.SpzaExcelGalleryPage) {
        metaObj = {
            metaDescription: getAppSourceExcelDescriptionTag(),
            metaKeywords: getAppSourceExcelGalleryKeywordsTag(),
            metaOGTitle: getAppSourcePageOGTitleTag({
                isConverged
            }),
            metaOGUrl: getOGtag(metaTagConstants.urlName, `${baseURL}${url}`),
            metaOGDescription: getAppSourceExcelGalleryOGDescriptionTag(),
            metaOGLocale: getOGtag(metaTagConstants.localeName, renderProps.params.locale ? renderProps.params.locale : 'en-us'),
            metaOGSiteName: getAppSourcePageOGSitename({
                isConverged
            })
        };
    } else if (page === Constants.PageToGiveMetaTag.SpzaPowerpointGalleryPage) {
        metaObj = {
            metaDescription: getAppSourcePptDescriptionTag(),
            metaKeywords: getAppSourcePptGalleryKeywordsTag(),
            metaOGTitle: getAppSourcePageOGTitleTag({
                isConverged
            }),
            metaOGUrl: getOGtag(metaTagConstants.urlName, `${baseURL}${url}`),
            metaOGDescription: getAppSourcePptGalleryOGDescriptionTag(),
            metaOGLocale: getOGtag(metaTagConstants.localeName, renderProps.params.locale ? renderProps.params.locale : 'en-us'),
            metaOGSiteName: getAppSourcePageOGSitename({
                isConverged
            })
        };
    } else if (page === Constants.PageToGiveMetaTag.SpzaOutlookGalleryPage) {
        metaObj = {
            metaDescription: getAppSourceOutlookDescriptionTag(),
            metaKeywords: getAppSourceOutlookGalleryKeywordsTag(),
            metaOGTitle: getAppSourcePageOGTitleTag({
                isConverged
            }),
            metaOGUrl: getOGtag(metaTagConstants.urlName, `${baseURL}${url}`),
            metaOGDescription: getAppSourceOutlookGalleryOGDescriptionTag(),
            metaOGLocale: getOGtag(metaTagConstants.localeName, renderProps.params.locale ? renderProps.params.locale : 'en-us'),
            metaOGSiteName: getAppSourcePageOGSitename({
                isConverged
            })
        };
    } else if (page === Constants.PageToGiveMetaTag.SpzaOfficeGalleryPage) {
        metaObj = {
            metaDescription: getAppSourceOfficeDescriptionTag(),
            metaKeywords: getAppSourceOfficeGalleryKeywordsTag(),
            metaOGTitle: getAppSourcePageOGTitleTag({
                isConverged
            }),
            metaOGUrl: getOGtag(metaTagConstants.urlName, `${baseURL}${url}`),
            metaOGDescription: getAppSourceOfficeGalleryOGDescriptionTag(),
            metaOGLocale: getOGtag(metaTagConstants.localeName, renderProps.params.locale ? renderProps.params.locale : 'en-us'),
            metaOGSiteName: getAppSourcePageOGSitename({
                isConverged
            })
        };
    } else if (page === Constants.PageToGiveMetaTag.SpzaGalleryPage) {
        metaObj = {
            metaDescription: getAppSourceHomeDescriptionTag({
                isConverged
            }),
            metaKeywords: getAppSourceGalleryKeywordsTag({
                isConverged
            }),
            metaOGTitle: getAppSourcePageOGTitleTag({
                isConverged
            }),
            metaOGUrl: getOGtag(metaTagConstants.urlName, `${baseURL}${url}`),
            metaOGDescription: getAppSourceGalleryOGDescriptionTag({
                isConverged
            }),
            metaOGLocale: getOGtag(metaTagConstants.localeName, renderProps.params.locale ? renderProps.params.locale : 'en-us'),
            metaOGSiteName: getAppSourcePageOGSitename({
                isConverged
            })
        };
    } else if (page === Constants.PageToGiveMetaTag.SpzaCSGalleryPage) {
        metaObj = {
            metaDescription: getAppSourceCSGalleryDescriptionTag({
                isConverged
            }),
            metaKeywords: getAppSourceCSGalleryKeywordsTag({
                isConverged
            }),
            metaOGTitle: getAppSourceCSGalleryOGTitleTag({
                isConverged
            }),
            metaOGUrl: getOGtag(metaTagConstants.urlName, `${baseURL}${url}`),
            metaOGDescription: getAppSourceCSGalleryOGDescriptionTag({
                isConverged
            }),
            metaOGLocale: getOGtag(metaTagConstants.localeName, renderProps.params.locale ? renderProps.params.locale : 'en-us'),
            metaOGSiteName: getAppSourcePageOGSitename({
                isConverged
            })
        };
    } else if (page === Constants.PageToGiveMetaTag.SpzaDetailPage) {
        const app = store.getState().apps.dataList.find((app)=>{
            var _app_entityId, _renderProps_params_entityId, _renderProps_params;
            return (app === null || app === void 0 ? void 0 : (_app_entityId = app.entityId) === null || _app_entityId === void 0 ? void 0 : _app_entityId.toLowerCase()) === (renderProps === null || renderProps === void 0 ? void 0 : (_renderProps_params = renderProps.params) === null || _renderProps_params === void 0 ? void 0 : (_renderProps_params_entityId = _renderProps_params.entityId) === null || _renderProps_params_entityId === void 0 ? void 0 : _renderProps_params_entityId.toLowerCase());
        });
        if (app) {
            let keywords = '';
            if (app.detailInformation && app.detailInformation.Keywords && app.detailInformation.Keywords.length > 0) {
                for(let i = 0; i < app.detailInformation.Keywords.length; i++){
                    if (i !== 0) {
                        keywords += ', ';
                    }
                    keywords += app.detailInformation.Keywords[`${i}`];
                }
            }
            let videoUrl = '';
            if (app.detailInformation && app.detailInformation.DemoVideos && app.detailInformation.DemoVideos.length > 0) {
                videoUrl = app.detailInformation.DemoVideos[0].VideoLink;
            }
            metaObj = {
                metaDescription: getMetaTag(metaTagConstants.desName, app.shortDescription),
                metaKeywords: getMetaTag(metaTagConstants.keywordsName, keywords),
                metaOGTitle: getOGtag(metaTagConstants.titleName, app.title),
                metaOGUrl: getOGtag(metaTagConstants.urlName, `${baseURL}${url}`),
                metaOGImage: getOGtag(metaTagConstants.imageName, app.iconURL),
                metaOGDescription: getOGtag(metaTagConstants.desName, app.shortDescription),
                metaOGLocale: getOGtag(metaTagConstants.localeName, renderProps.params.locale ? renderProps.params.locale : 'en-us'),
                metaOGSiteName: getOGtag(metaTagConstants.sitenameName, app.title),
                metaOGVideo: getOGtag(metaTagConstants.videoName, videoUrl),
                metaTwitterCard: getMetaTag(metaTagConstants.twitterCard, metaTagConstants.twitterCardValue),
                metaTwitterSite: getMetaTag(metaTagConstants.twitterSite, metaTagConstants.twitterSiteValue),
                metaTwitterTitle: getMetaTag(metaTagConstants.twitterTitle, app.title),
                metaTwitterDescription: getMetaTag(metaTagConstants.twitterDes, app.shortDescription),
                metaTwitterImage: getMetaTag(metaTagConstants.twitterImage, app.iconURL)
            };
        }
    } else if (page === Constants.PageToGiveMetaTag.SpzaCSDetailPage) {
        const csApp = store.getState().services.dataList.find((app)=>{
            var _app_entityId, _renderProps_params_entityId, _renderProps_params;
            return (app === null || app === void 0 ? void 0 : (_app_entityId = app.entityId) === null || _app_entityId === void 0 ? void 0 : _app_entityId.toLowerCase()) === (renderProps === null || renderProps === void 0 ? void 0 : (_renderProps_params = renderProps.params) === null || _renderProps_params === void 0 ? void 0 : (_renderProps_params_entityId = _renderProps_params.entityId) === null || _renderProps_params_entityId === void 0 ? void 0 : _renderProps_params_entityId.toLowerCase());
        });
        if (csApp) {
            var _csApp_extraData, _csApp_extraData1, _csApp_extraData2;
            let videoUrl = '';
            if (csApp.detailInformation && csApp.detailInformation.DemoVideos && csApp.detailInformation.DemoVideos.length > 0) {
                videoUrl = csApp.detailInformation.DemoVideos[0].VideoLink;
            }
            metaObj = {
                metaDescription: getMetaTag(metaTagConstants.desName, (_csApp_extraData = csApp.extraData) === null || _csApp_extraData === void 0 ? void 0 : _csApp_extraData.shortDescription),
                metaKeywords: getMetaTag(metaTagConstants.keywordsName, csApp.title + ', consulting service'),
                metaOGTitle: getOGtag(metaTagConstants.titleName, csApp.title),
                metaOGUrl: getOGtag(metaTagConstants.urlName, `${baseURL}${url}`),
                metaOGImage: getOGtag(metaTagConstants.imageName, csApp.detailInformation.LargeIconUri),
                metaOGDescription: getOGtag(metaTagConstants.desName, (_csApp_extraData1 = csApp.extraData) === null || _csApp_extraData1 === void 0 ? void 0 : _csApp_extraData1.shortDescription),
                metaOGLocale: getOGtag(metaTagConstants.localeName, renderProps.params.locale ? renderProps.params.locale : 'en-us'),
                metaOGSiteName: getOGtag(metaTagConstants.sitenameName, csApp.title),
                metaOGVideo: getOGtag(metaTagConstants.videoName, videoUrl),
                metaTwitterCard: getMetaTag(metaTagConstants.twitterCard, metaTagConstants.twitterCardValue),
                metaTwitterSite: getMetaTag(metaTagConstants.twitterSite, metaTagConstants.twitterSiteValue),
                metaTwitterTitle: getMetaTag(metaTagConstants.twitterTitle, csApp.title),
                metaTwitterDescription: getMetaTag(metaTagConstants.twitterDes, (_csApp_extraData2 = csApp.extraData) === null || _csApp_extraData2 === void 0 ? void 0 : _csApp_extraData2.shortDescription),
                metaTwitterImage: getMetaTag(metaTagConstants.twitterImage, csApp.detailInformation.LargeIconUri)
            };
        }
    }
    return metaObj;
}
export var metaTagConstants;
